import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../../config/theme';

export class ProfileItem extends Lightning.Component {
  static _template() {
    const avatarSize = 60;
    const textOffset = 130;

    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      background: {
        x: 0,
        y: 0,
        w: w => w,
        h: h => h,
        color: 0xff800000,
        rect: true,
      },
      User: {
        x: textOffset,
        y: 45,
        w: w => w - textOffset,
        h: 40,
        text: {
          fontSize: 28,
          fontFace: 'Regular',
        },
        color: Theme.Colors.Menu.Active,
      },
      Avatar: {
        // mountY: 0.5,
        x: 35,
        y: 35,
        w: avatarSize,
        h: avatarSize,
        // src: this.bindProp('icon'),
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: avatarSize * 0.5,
        },
      },
      FocusLine: {
        y: 80,
        h: 4,
        w: 30,
        x: textOffset,
        color: Theme.Colors.Primary,
        alpha: 0,
        rect: true,
      },
    };
  }

  set label(value) {
    this.tag('User').text.text = value;
  }

  set avatar(url) {
    this.tag('Avatar').src = url;
  }

  _focus() {
    this.tag('FocusLine').setSmooth('alpha', 1);
  }

  _unfocus() {
    this.tag('FocusLine').setSmooth('alpha', 0);
  }

  _handleEnter() {
    this.signal('onActivate', this);
  }
}
